export class PagedContent<T> {
    PageNumber: number;
    Content: T;

    constructor(pageNumber: number, content: T) {
        this.PageNumber = pageNumber;
        this.Content = content;
    }
   }

